import React from 'react'
import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import AutoCaptionField from '../../../../../form-fields/super-cut/auto-caption'

const AutoCaption = styled(AutoCaptionField)`
    grid-column: span 1;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoAutoCaptionField = ({ field }: Props) => {
    return (
        <AutoCaption
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoAutoCaptionField
